import oneDay from '../assets/release-2026-10-27/kalender-ansicht-01-ein-tag.png'
import threeDays from '../assets/release-2026-10-27/kalender-ansicht-02-umschalten.png'
import { makeBox, type GuideStepContent } from './guideStep'

export const KALENDER_ANSICHT_INTRO =
  'Am Handy zeigt der Kalender jetzt einen Tag. Die Termine sind größer und zeigen mehr Infos. Wer mehrere Tage sehen will, schaltet auf drei Tage um.'

export const KALENDER_ANSICHT_STEPS: GuideStepContent[] = [
  {
    title: 'Ein Tag',
    text: 'Nach der Anmeldung sehen Sie Ihren Kalender mit dem heutigen Tag. Mit den Pfeilen oben blättern Sie einen Tag vor oder zurück.',
    image: oneDay,
    imageAlt: 'Kalender am Handy in der Tagesansicht',
    focus: [makeBox(394, 853)(80, 65, 170, 110)],
  },
  {
    title: 'Auf drei Tage umschalten',
    text: 'Oben rechts stehen zwei Symbole: links „Ein Tag“, rechts „Drei Tage“. Tippen Sie auf das rechte Symbol, um drei Tage nebeneinander zu sehen. Mit dem linken kommen Sie zurück zur Tagesansicht.',
    image: threeDays,
    imageAlt: 'Kalender am Handy in der Ansicht „Drei Tage“',
    focus: [makeBox(395, 856)(256, 65, 335, 110)],
  },
]
